import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { withRouter } from "react-router";
import ruLocale from "date-fns/locale/ru";
import { Button, Link } from "@lifepay/rc-ui-toolkit";

import HumanReadableDate from "components/utils/HumanReadableDate";
import HintedMCC from "components/utils/HintedMCC";

// import Labeled from "components/visual/Labeled";
// import Details from "components/visual/Details";

import styles from "./Terminal.m.scss";

function Terminal(props) {
  const {
    theme,
    item,
    // selectedTerminal,
    // selectTerminal,
    goToCompanies,
    goToMerchants,
    goToTransactions,
  } = props;

  return (
    <div
      className={classnames(
        theme.wrapper
        // selectedTerminal && selectedTerminal.id === item.id && theme.active
      )}
      // onClick={() => selectTerminal(item)}
    >
      <div>{item.id}</div>
      <div>
        {item.companyId ? (
          <Link
            withRouter={false}
            type={"alt"}
            onClick={() =>
              goToCompanies({
                search: `company-id=${item.companyId}`,
                state: {
                  routerStateQuery: {
                    companyId: item.companyId,
                  },
                },
              })
            }
          >
            {item.companyId}
          </Link>
        ) : (
          "-"
        )}
      </div>
      <div>
        {item.companyName ? (
          <Link
            withRouter={false}
            type={"alt"}
            onClick={() =>
              goToCompanies({
                search: `company-name=${item.companyName}`,
                state: {
                  routerStateQuery: {
                    companyName: item.companyName,
                  },
                },
              })
            }
          >
            {item.companyName}
          </Link>
        ) : (
          "-"
        )}
      </div>
      <div>
        {item.merchantId ? (
          <Link
            withRouter={false}
            type={"alt"}
            onClick={() =>
              goToMerchants({
                search: `merchant-ids=${item.merchantId}`,
                state: {
                  routerStateQuery: {
                    merchantIds: item.merchantId,
                  },
                },
              })
            }
          >
            {item.merchantId}
          </Link>
        ) : (
          "-"
        )}
      </div>
      <div>
        {item.merchantName ? (
          <Link
            withRouter={false}
            type={"alt"}
            onClick={() =>
              goToMerchants({
                search: `merchant-name=${item.merchantName}`,
                state: {
                  routerStateQuery: {
                    merchantName: item.merchantName,
                  },
                },
              })
            }
          >
            {item.merchantName}
          </Link>
        ) : (
          "-"
        )}
      </div>
      <HumanReadableDate
        date={item.lastTransactionDate}
        locale={ruLocale}
        NoDate={<div className={classnames(theme.red)}>{"Не установлен"}</div>}
      />
      <HumanReadableDate
        date={item.lastSuccessTransactionDate}
        locale={ruLocale}
        NoDate={<div className={classnames(theme.red)}>{"Не установлен"}</div>}
      />
      <div>
        {item.mcc ? (
          <HintedMCC theme={{ wrapper: theme.mcc }} code={item.mcc} />
        ) : (
          "-"
        )}
      </div>
      {typeof item.hasChip === "boolean" ? (
        <div className={classnames(item.hasChip ? theme.green : theme.red)}>
          {item.hasChip ? "✓" : "❌"}
        </div>
      ) : (
        item.hasChip
      )}
      <div>
        <Button
          theme={{ wrapper: theme.button }}
          size={"small"}
          type={"alt"}
          onClick={() => {
            goToTransactions({
              search: `?terminal-id=${item.id}`,
              state: {
                routerStateQuery: {
                  terminalId: item.id,
                },
              },
            });
          }}
        >
          {"Транзакции"}
        </Button>
      </div>
    </div>
  );
}

Terminal.displayName = "Terminal";

Terminal.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
  history: PropTypes.object,
  basePath: PropTypes.string,
  selectTerminal: PropTypes.func,
  goToCompanies: PropTypes.func,
  goToMerchants: PropTypes.func,
  goToTransactions: PropTypes.func,
  selectedTerminal: PropTypes.object,
};

Terminal.defaultProps = {};

export default withRouter(themr("@lifepay/Terminal", styles)(Terminal));



// WEBPACK FOOTER //
// ./src/components/list-items/compact/Terminal/Terminal.js